import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { loginStyle } from '../../styles/auth/success';


export function Success() {
  return(
    <Stack component="section" sx={loginStyle.contentStack}>
      <Box>
        <Typography color="primary" sx={loginStyle.contentStackBoxTypography}>Login success! Redirecting you to Dashboard...</Typography>
      </Box>
    </Stack>
  )
}